import { gql } from '__generated__'

/**
 * Unlinks a wallet that is not primary from the signed-in user (backend PR
 * #189). The answer carries the wallets left, so the cached `me` updates
 * without a refetch.
 */
export const UNLINK_WALLET = gql(`
  mutation unlinkWallet($walletAddress: String!) {
    unlinkWallet(walletAddress: $walletAddress) {
      id
      primaryWalletAddress
      wallets {
        id
        address
        isPrimary
        createdAt
      }
    }
  }
`)
